import httpClient from './httpClient';

export default {
    getByTemplateId: (templateId, version) => {
        return httpClient.get(`/api/HealthCheckTemplates/${templateId}/${version}?code=YiI517EIAafsnyB_948QxiQcpAwsWyJ2O_fjNs8P43rZAzFu9UOTCg==`)
            .then(resp => resp.data);
    },
};